import { create } from "zustand";

interface NoteSectionCollapseStore {
  collapsedByNote: Record<string, Record<string, boolean>>;
  updateCollapsed: (
    scope: string,
    updater: (sections: Record<string, boolean>) => Record<string, boolean>,
  ) => void;
}

// Saving navigates to a new revision and can remount the editor. Keep this
// session-only UI state outside the component, keyed by tenant and note root.
export const useNoteSectionCollapseStore = create<NoteSectionCollapseStore>(
  (set) => ({
    collapsedByNote: {},
    updateCollapsed: (scope, updater) =>
      set((state) => ({
        collapsedByNote: {
          ...state.collapsedByNote,
          [scope]: updater(state.collapsedByNote[scope] ?? {}),
        },
      })),
  }),
);
